import Industry, {IndustryInput} from '../../industry/data/Industry';

export type BrandInput = {
    id?: string;
    name: string;
    industries?: Array<IndustryInput | Industry> | null;
    hasAccess?: boolean | null;
};

export default class Brand {
    private data: BrandInput;
    private baseUrl: string;
    private mediaUrl = process.env.MEDIA_URL ?? '';
    type = 'brand' as const;

    constructor(input: BrandInput) {
        this.data = input;
        this.baseUrl = `${Brand.to(input.name)}/`;
    }

    static to(name: string) {
        return `/advertiser/${encodeURIComponent(name)}`;
    }

    get id() {
        return this.data.id || this.data.name;
    }

    // exposed for consistency with other entity types
    get name() {
        return this.data.name;
    }

    get label() {
        return this.data.name;
    }

    get logoUrl() {
        const name = sanitizeBrandName(this.data.name);
        return `${this.mediaUrl}logo-v2/${name}/logo.png`;
    }

    get to() {
        return `${this.baseUrl}creative`;
    }

    toMediaValue(params?: {startDate?: string; endDate?: string}) {
        let query = '';
        if (params) {
            const q = JSON.stringify({
                industry: 'All',
                'industry.lens': 'Historical',
                'industry.chart': 'Line',
                'mediaType.lens': 'Historical',
                'mediaType.chart': 'Stacked',
                'adType.lens': 'Historical',
                'adType.chart': 'Stacked',
                'region.lens': 'Historical',
                'region.chart': 'Stacked',
                'category.lens': 'Historical',
                'category.chart': 'Stacked',
                dateRangeFilter: {
                    absolute: {startDate: params.startDate, endDate: params.endDate}
                }
            });
            query = `?${new URLSearchParams({q})}`;
        }

        return `${this.baseUrl}value${query}`;
    }

    get trackingType() {
        return {type: 'brand', name: this.label};
    }

    get color() {
        return undefined;
    }

    get industryList() {
        if (!this.data.industries) return [];
        return this.data.industries.map((ii) => (ii instanceof Industry ? ii : new Industry(ii)));
    }

    get hasAccess() {
        return this.data.hasAccess ?? null;
    }
}

function sanitizeBrandName(name: string): string {
    return name
        .trim()
        .toLowerCase()
        .replace(/&/g, 'and')
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
        .replace(/^-+|-+$/g, '');
}
